import { useEffect, useRef } from 'react';

const useInactivityTimer = (timeout = 15 * 60 * 1000) => { // 15 minutes
    const timeoutRef = useRef(null);

    const handleActivity = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            // Redirect to login page or perform logout
            localStorage.clear();
            window.location.href = '/'
            // Adjust based on your routes
        }, timeout);
    };

    useEffect(() => {

        // Check if this is a new session
        const isNewSession = !sessionStorage.getItem('sessionStarted');
        
        if (isNewSession) {
            // Mark this as an active session
            sessionStorage.setItem('sessionStarted', 'true');
            
            // If we have tokens but it's a new session, clear them
            if (localStorage.getItem('accessToken')) {
                localStorage.clear();
                window.location.href = '/';
            }
        }
        
        // Set up event listeners for user activity
        window.addEventListener('mousemove', handleActivity);
        window.addEventListener('keydown', handleActivity);
        window.addEventListener('click', handleActivity);
        window.addEventListener('scroll', handleActivity);

        return () => {
            // Clean up event listeners on component unmount
            window.removeEventListener('mousemove', handleActivity);
            window.removeEventListener('keydown', handleActivity);
            window.removeEventListener('click', handleActivity);
            window.removeEventListener('scroll', handleActivity);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
};

export default useInactivityTimer;
